// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__WDGNU","inactive":"Sidebar_inactive__oPKA5","navIcon":"Sidebar_navIcon__hqabd","navBtn":"Sidebar_navBtn__pAmhm"};